var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAllCustomers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFD05B",
    d: "M21.314.558c11.322 0 20.5 9.178 20.5 20.5s-9.178 20.5-20.5 20.5-20.5-9.178-20.5-20.5 9.178-20.5 20.5-20.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF7058",
    d: "M30.386 9.016H12.049a.427.427 0 0 0-.42.42V32.68c0 .226.194.42.42.42h18.337c.226 0 .42-.194.42-.42V9.436a.407.407 0 0 0-.42-.42"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E9EE",
    d: "M30.805 14.343h2.163v-3.97h-2.163z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#324A5E",
    d: "M30.805 18.314h2.163v-3.97h-2.163z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4CDBC4",
    d: "M30.805 22.253h2.163v-3.971h-2.163z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2B3B4E",
    d: "M30.805 26.223h2.163v-3.97h-2.163z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#324A5E",
    d: "M12.888 12.89h-2.55a.717.717 0 0 0-.71.71v.033c0 .387.322.71.71.71h2.55c.387 0 .71-.323.71-.71v-.065c0-.387-.323-.678-.71-.678M12.888 20.251h-2.55a.717.717 0 0 0-.71.71v.065c0 .387.322.71.71.71h2.55c.387 0 .71-.323.71-.71v-.065c0-.42-.323-.71-.71-.71M12.888 27.612h-2.55a.717.717 0 0 0-.71.71v.065c0 .387.322.71.71.71h2.55c.387 0 .71-.323.71-.71v-.065a.717.717 0 0 0-.71-.71"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M22.511 21.294l-1.726-.835a.459.459 0 0 1-.264-.413v-.592a3.955 3.955 0 0 0 .664-1.18.693.693 0 0 0 .42-.633v-.699a.685.685 0 0 0-.18-.459v-.93c.01-.096.05-.669-.379-1.141-.37-.41-.973-.618-1.79-.618-.817 0-1.42.208-1.79.618a1.532 1.532 0 0 0-.379 1.14v.931a.685.685 0 0 0-.18.459v.7c0 .212.1.41.27.543.166.634.512 1.112.633 1.266v.578a.46.46 0 0 1-.249.406l-1.612.85a1.57 1.57 0 0 0-.85 1.386v.566c0 .83 2.72 1.05 4.157 1.05 1.437 0 4.156-.22 4.156-1.05v-.532c0-.601-.345-1.142-.9-1.41z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M26.708 24.603l-1.726-.835a.459.459 0 0 1-.264-.413v-.592a3.955 3.955 0 0 0 .664-1.18.693.693 0 0 0 .42-.632v-.7a.685.685 0 0 0-.18-.459v-.93c.01-.096.05-.669-.379-1.141-.37-.41-.973-.618-1.79-.618-.817 0-1.42.208-1.79.618a1.532 1.532 0 0 0-.379 1.14v.931a.685.685 0 0 0-.18.46v.699c0 .212.1.41.27.543.165.634.512 1.112.633 1.266v.578a.46.46 0 0 1-.249.406l-1.612.851a1.57 1.57 0 0 0-.85 1.385v.566c0 .83 2.72 1.05 4.157 1.05 1.437 0 4.156-.22 4.156-1.05v-.532c0-.601-.345-1.142-.9-1.41z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllCustomers);
export default __webpack_public_path__ + "static/media/all_customers.5676828a2bb675a5dfad1d3e4f035d8f.svg";
export { ForwardRef as ReactComponent };